try {
  if (window.legendsVoyado?.elevate) {
    window.voyadoApi = window.legendsVoyado.elevate({
      clusterId: 'wA11390A7',
      market: 'US',
      locale: 'en-US',
      touchpoint: window.innerWidth > 768 ? 'desktop' : 'mobile',
      session: window.legendsVoyado.localStorageBackedSession(),
    });
    window.elevate = window.voyadoApi;
  } else {
    console.error('Legends Voyado Scripts not loaded');
  }
} catch (error) {
  console.error('voyado: failed to init Elevate', error);
}


function ensureSwiper() {
  const assets = window.voyadoAssets || {};
  const loads = [];

  if (assets.swiperCss && !document.querySelector('link[data-voyado-swiper-css]')) {
    loads.push(
      new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = assets.swiperCss;
        link.setAttribute('data-voyado-swiper-css', '');
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
      }),
    );
  }

  if (!window.Swiper && assets.swiperJs) {
    loads.push(
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = assets.swiperJs;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      }),
    );
  }

  return Promise.all(loads);
}

const VOYADO_SLIDER_ARROW_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12.5998 11.9998L8.6998 8.0998C8.51647 7.91647 8.4248 7.68314 8.4248 7.3998C8.4248 7.11647 8.51647 6.88314 8.6998 6.6998C8.88314 6.51647 9.11647 6.4248 9.3998 6.4248C9.68314 6.4248 9.91647 6.51647 10.0998 6.6998L14.6998 11.2998C14.7998 11.3998 14.8706 11.5081 14.9123 11.6248C14.954 11.7415 14.9748 11.8665 14.9748 11.9998C14.9748 12.1331 14.954 12.2581 14.9123 12.3748C14.8706 12.4915 14.7998 12.5998 14.6998 12.6998L10.0998 17.2998C9.91647 17.4831 9.68314 17.5748 9.3998 17.5748C9.11647 17.5748 8.88314 17.4831 8.6998 17.2998C8.51647 17.1165 8.4248 16.8831 8.4248 16.5998C8.4248 16.3165 8.51647 16.0831 8.6998 15.8998L12.5998 11.9998Z" fill="#101010"/></svg>`;

function bindVoyadoProgress(swiper, progressRoot) {
  const bar = progressRoot.querySelector('.progress-bar');
  const fill = progressRoot.querySelector('.progress-bar-fill');
  if (!bar || !fill) return;
  let dragging = false;

  function setFill(ratio) {
    const percent = Math.max(0, Math.min(1, ratio)) * 100;
    fill.style.width = `${percent}%`;
  }

  function progressRatio() {
    const total = swiper.slides.length;
    if (!total) return 0;
    const perView =
      typeof swiper.slidesPerViewDynamic === 'function'
        ? swiper.slidesPerViewDynamic()
        : swiper.params.slidesPerView || 1;
    const visible = Number(perView) || 1;
    const current = Math.min(total, swiper.activeIndex + visible);
    return current / total;
  }

  function syncFromSwiper() {
    if (dragging) return;
    fill.style.transition = 'width 0.3s ease';
    setFill(swiper.isBeginning && swiper.isEnd ? 1 : progressRatio());
  }

  function seek(clientX) {
    const rect = bar.getBoundingClientRect();
    if (!rect.width) return;
    const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
    fill.style.transition = 'none';
    setFill(ratio);
    const maxIndex = Math.max((swiper.snapGrid?.length || 1) - 1, 0);
    swiper.slideTo(Math.round(ratio * maxIndex));
  }

  function pointerX(event) {
    if (event.touches && event.touches[0]) return event.touches[0].clientX;
    if (event.changedTouches && event.changedTouches[0]) {
      return event.changedTouches[0].clientX;
    }
    return event.clientX;
  }

  function onDown(event) {
    dragging = true;
    bar.classList.add('is-dragging');
    seek(pointerX(event));
  }

  function onMove(event) {
    if (!dragging) return;
    seek(pointerX(event));
  }

  function onUp() {
    if (!dragging) return;
    dragging = false;
    bar.classList.remove('is-dragging');
    fill.style.transition = 'width 0.3s ease';
  }

  bar.addEventListener('mousedown', onDown);
  bar.addEventListener('touchstart', onDown, { passive: true });
  document.addEventListener('mousemove', onMove);
  document.addEventListener('touchmove', onMove, { passive: true });
  document.addEventListener('mouseup', onUp);
  document.addEventListener('touchend', onUp);

  swiper.on('slideChange', syncFromSwiper);
  swiper.on('progress', syncFromSwiper);
  swiper.on('resize', syncFromSwiper);
  syncFromSwiper();
}

function mountVoyadoCarousel(container, productGroups) {
  if (!container || !window.Swiper) return null;
  const groups = (productGroups || []).filter((group) => group?.products?.[0]);
  if (!groups.length) return null;

  const shell = document.createElement('div');
  shell.className = 'voyado-slider-shell';
  shell.innerHTML = `
    <div class="voyado-slider swiper">
      <div class="swiper-wrapper"></div>
    </div>
    <div class="progress-wrapper voyado-slider__progress">
      <div class="progress-bar">
        <span class="progress-bar-fill"></span>
      </div>
      <div class="slider-arrows">
        <button type="button" class="voyado-slider__prev arrow-prev" aria-label="Previous slide">${VOYADO_SLIDER_ARROW_SVG}</button>
        <button type="button" class="voyado-slider__next" aria-label="Next slide">${VOYADO_SLIDER_ARROW_SVG}</button>
      </div>
    </div>
  `;

  const slider = shell.querySelector('.voyado-slider');
  const wrapper = slider.querySelector('.swiper-wrapper');
  groups.forEach((group) => {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide';
    slide.appendChild(new VoyadoProductCard(group.products[0]));
    wrapper.appendChild(slide);
  });

  container.innerHTML = '';
  container.appendChild(shell);

  const swiper = new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 16,
    slidesPerGroup: 1,
    watchOverflow: true,
    navigation: {
      nextEl: shell.querySelector('.voyado-slider__next'),
      prevEl: shell.querySelector('.voyado-slider__prev'),
    },
    breakpoints: {
      500: { slidesPerView: 2.2 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 4 },
    },
  });

  bindVoyadoProgress(swiper, shell.querySelector('.voyado-slider__progress'));
  return swiper;
}

function voyadoEscapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function voyadoFormatPrice(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return '';
  return `$${number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function voyadoCardTheme() {
  const theme = window.voyadoTheme || {};
  return {
    cardStyle: theme.cardStyle || 'standard',
    cardColorScheme: theme.cardColorScheme || 'scheme-2',
  };
}

class VoyadoProductCard extends HTMLElement {
  constructor(productData) {
    super();
    this.productData = productData;
    this.noNotification = this.getAttribute('no-notification') || false;
  }

  connectedCallback() {
    if (this.noNotification) return;
    this.buildProductCard();
    this.addNotificationOnClick();
  }

  buildProductCard() {
    const productData = this.productData || {};
    const theme = voyadoCardTheme();
    const thumbnail = productData.imageInfo?.images?.[0];
    const secondaryImage = productData.imageInfo?.images?.[1];
    const link = productData.link || '#';
    const title = productData.title || '';
    const productKey = productData.key || productData.productKey || '';
    const thumbnailUrl = thumbnail?.sources?.[0]?.url || '';
    const secondaryUrl = secondaryImage?.sources?.[0]?.url || '';
    const hasMedia = Boolean(thumbnailUrl);
    const onSale =
      Number(productData.listPrice?.min) > Number(productData.sellingPrice?.min);
    const sellingPrice = voyadoFormatPrice(productData.sellingPrice?.min);
    const listPrice = voyadoFormatPrice(productData.listPrice?.min);
    const priceHtml = onSale
      ? `<div class="price price--on-sale">
          <div class="price__container">
            <div class="price__sale">
              <span>
                <s class="price-item price-item--regular">${listPrice}</s>
              </span>
              <span class="price-item price-item--sale price-item--last">${sellingPrice}</span>
            </div>
          </div>
        </div>`
      : `<div class="price">
          <div class="price__container">
            <div class="price__regular">
              <span class="price-item price-item--regular">${sellingPrice}</span>
            </div>
          </div>
        </div>`;
    const secondaryImg = secondaryUrl
      ? `<img src="${voyadoEscapeHtml(secondaryUrl)}" alt="${voyadoEscapeHtml(secondaryImage?.alt || title)}" class="motion-reduce" loading="lazy">`
      : '';
    const mediaHtml = hasMedia
      ? `<div class="card__media">
            <div class="media media--transparent media--hover-effect">
              <img src="${voyadoEscapeHtml(thumbnailUrl)}" alt="${voyadoEscapeHtml(thumbnail?.alt || title)}" class="motion-reduce" loading="lazy">
              ${secondaryImg}
            </div>
          </div>`
      : '';
    const cardClasses = [
      'card',
      `card--${theme.cardStyle}`,
      hasMedia ? 'card--media' : 'card--text',
    ].join(' ');
    const innerClasses = [
      'card__inner',
      theme.cardStyle === 'standard' ? `color-${theme.cardColorScheme} gradient` : '',
      hasMedia || theme.cardStyle === 'standard' ? 'ratio' : '',
    ]
      .filter(Boolean)
      .join(' ');

    this.innerHTML = `
      <div class="card-wrapper product-card-wrapper underline-links-hover"${productKey ? ` product-id="${voyadoEscapeHtml(productKey)}"` : ''} role="group" aria-label="${voyadoEscapeHtml(title)}">
        <div class="${cardClasses}" style="--ratio-percent: 100%;">
          <div class="${innerClasses}" style="--ratio-percent: 100%;">
            ${mediaHtml}
          </div>
          <div class="card__content">
            <div class="card__information">
              <div class="card__heading h5">
                <a href="${voyadoEscapeHtml(link)}" class="full-unstyled-link">${voyadoEscapeHtml(title)}</a>
              </div>
              <div class="card-information">
                ${priceHtml}
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  addNotificationOnClick() {
    const cardLink = this.querySelector('a.full-unstyled-link') || this.querySelector('a');
    if (!cardLink) return;

    cardLink.addEventListener('click', (e) => {
      const ticket = this.productData?.ticket;
      const href = this.productData?.link;
      if (!ticket || !href) return;

      e.preventDefault();
      window.voyadoApi.notify.click(ticket).finally(() => {
        window.location.href = href;
      });
    });
  }
}

class VoyadoProductGrid extends HTMLElement {
  constructor() {
    super();
    this.pageReference = null;
    this.limit = 24;
    this.skip = 0;
    this.sort = 'RELEVANCE';
    this.facets = {};
    this.priceRange = {};
  }

  async connectedCallback() {
    this.pageReference = this.getAttribute('page-reference') || '';
    if (this.pageReference === '') {
      console.error('voyado: page reference is required');
      return;
    }
    if (!window.legendsVoyado) {
      console.error('Legends Voyado Scripts not loaded');
      return;
    }
    const data = await this.getGridData({}, {}, true);

    this.buildVoyadoSection(data);
  }

  async getGridData(customParams = {}, customBody = {}, resetSkip = true) {
    const params = {
      pageReference: this.pageReference,
      limit: this.limit,
      skip: this.skip,
      ...customParams,
    };
    const body = {
      primaryList: {
        include: true,
      },
      ...customBody,
    };

    const response = await window.voyadoApi.query.landingPage(params, body);

    if (resetSkip) {
      this.skip = 0;
    }
    this.skip += response.primaryList?.productGroups?.length || 0;

    return response;
  }

  buildProductGrid(data) {
    const productGroups = data.primaryList?.productGroups || [];
    const productGrid = this.querySelector('.voyado-collection__product-grid');
    productGrid.innerHTML = '';
    productGroups.forEach((productGroup) => {
      const voyadoProductCard = this.initProductCard(productGroup);
      productGrid.appendChild(voyadoProductCard);
    });

    if (!data.primaryList?.totalHits) {
      productGrid.innerHTML =
        '<div class="voyado-collection__no-results">No results found</div>';
    }

    return productGrid;
  }

  buildNoResultsSlider(data) {
    const slider = document.createElement('div');
    slider.innerHTML = `
    <voyado-slider page-reference="/" limit="16">
      <h2 class="voyado-slider__title">
        Top Products
      </h2>
              <div class="voyado-slider__container"></div>
    </voyado-slider>
    `;
    return slider;
  }

  updateProductCardAriaLabels() {
    const productCards = document.querySelectorAll('voyado-product-card');

    productCards.forEach((productCard, index) => {
      productCard.setAttribute(
        'aria-label',
        `Product ${index + 1} of ${productCards.length}`,
      );
    });
  }

  initProductCard(productGroup) {
    const voyadoProductCard = document.createElement('voyado-product-card');
    voyadoProductCard.productData = productGroup.products[0];
    return voyadoProductCard;
  }

  buildVoyadoSection(data) {
    const voyadoSection = this.querySelector('.voyado-collection__wrapper');
    const voyadoLoadMoreContent = this.buildLoadMoreButton(data);
    const mobileFilter = this.buildMobileFilter(data);

    if (data.primaryList?.totalHits > 0) {
      //voyadoSection.appendChild(this.buildDidYouMean(data));
      voyadoSection.appendChild(mobileFilter);
      voyadoSection.appendChild(this.buildProductGrid(data));
      voyadoSection.appendChild(voyadoLoadMoreContent);
      this.buildfilterDrawer(data);
    } else {
      const noResultsFilter = this.querySelector(
        '.voyado-collection__mobile-filter',
      );
      if (noResultsFilter) noResultsFilter.innerHTML = '';
      voyadoSection.appendChild(this.buildProductGrid(data));
      voyadoSection.appendChild(this.buildNoResultsSlider(data));
    }

    this.appendChild(voyadoSection);
    this.updateProductCardAriaLabels();
    this.updateSEOTitle(data);
  }

  buildDidYouMean(data) {
    const didYouMean = data.didYouMean;
    const didYouMeanContainer = document.createElement('div');
    didYouMeanContainer.className = 'voyado-collection__did-you-mean';
    const didYouMeanItem = (suggestion) => {
      return `
      <a href="/search?q=${suggestion.q}">${suggestion.q}</a>
      `;
    };
    didYouMean.forEach((suggestion) => {
      didYouMeanContainer.appendChild(didYouMeanItem(suggestion));
    });
    return didYouMeanContainer;
  }

  // Collections keep the page title Shopify renders. VoyadoSearch overrides
  // this to set a search-specific title.
  updateSEOTitle() {}

  resultCount(data) {
    const resultCount = `<div class="voyado-collection__result-count">Showing 1 - ${this.skip} of ${data.primaryList?.totalHits}</div>`;
    return resultCount;
  }

  buildMobileFilter(data) {
    const mobileFilterContainer = this.querySelector(
      '.voyado-collection__mobile-filter',
    );
    mobileFilterContainer.innerHTML = `
    <div class="voyado-collection__mobile-filter-wrap">
      <div class="voyado-collection__mobile-filter-item">
        <button class="voyado-collection__mobile-filter-button">
          <span>Filter and sort</span>
        </button>
      </div>
      <div class="voyado-collection__result-count-wrap">
            ${this.resultCount(data)}
      </div>
    </div>
    ${this.buildActiveFilters(data)}
    `;

    const mobileFilterButton = mobileFilterContainer.querySelector(
      '.voyado-collection__mobile-filter-button',
    );
    mobileFilterButton.addEventListener('click', (e) => {
      e.preventDefault();
      const filterDrawer = document.querySelector(
        '.voyado-collection__filter-drawer',
      );
      filterDrawer.classList.add('open');
    });
    this.bindActiveFilterEvents(mobileFilterContainer);
    return mobileFilterContainer;
  }

  getFacetValues(facet) {
    if (facet?.type === 'SIZE') {
      return facet.sizeTypes?.[0]?.formats?.[0]?.values || [];
    }
    return facet?.values || [];
  }

  isFacetValueSelected(facetId, value) {
    if (value?.selected) return true;
    const applied = this.facets?.[`f.${facetId}`];
    if (!applied) return false;
    return applied.split('|').includes(String(value.id));
  }

  getSelectedFacetEntries(data) {
    const entries = [];
    const facets = data?.primaryList?.facets || [];
    facets.forEach((facet) => {
      if (facet.type === 'RANGE') return;
      this.getFacetValues(facet).forEach((value) => {
        if (this.isFacetValueSelected(facet.id, value)) {
          entries.push({
            facetId: facet.id,
            facetLabel: facet.label,
            value,
          });
        }
      });
    });
    return entries;
  }

  closeIconSmall() {
    return `
    <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    `;
  }

  buildActiveFilterPill(facetId, facetLabel, value) {
    return `
      <button
        type="button"
        class="active-facets__button active-facets__button--light voyado-remove-filter"
        data-facet-id="${facetId}"
        data-value-id="${value.id}"
      >
        <span class="active-facets__button-inner button button--tertiary">
          ${facetLabel}: ${value.label}
          ${this.closeIconSmall()}
          <span class="visually-hidden">Clear filter</span>
        </span>
      </button>
    `;
  }

  buildActiveFilters(data) {
    const entries = this.getSelectedFacetEntries(data);
    // Show pills with a single selection (no length > 1 gate).
    const pills = entries
      .map(({ facetId, facetLabel, value }) =>
        this.buildActiveFilterPill(facetId, facetLabel, value),
      )
      .join('');
    const clearAll = entries.length
      ? `
      <button type="button" class="voyado-clear-all active-facets__button-remove underlined-link">
        <span>Clear all</span>
      </button>
    `
      : '';

    return `
      <div class="voyado-active-filters active-facets${entries.length ? ' has-filters' : ' is-empty'}">
        ${pills}
        ${clearAll}
      </div>
    `;
  }

  bindActiveFilterEvents(root) {
    root.querySelectorAll('.voyado-remove-filter').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.removeFacetValue(button.dataset.facetId, button.dataset.valueId);
      });
    });
    const clearAll = root.querySelector('.voyado-clear-all');
    if (clearAll) {
      clearAll.addEventListener('click', (e) => {
        e.preventDefault();
        this.clearAllFilters();
      });
    }
  }

  async removeFacetValue(facetId, valueId) {
    const key = `f.${facetId}`;
    if (this.facets[key]) {
      const next = this.facets[key]
        .split('|')
        .filter((value) => value !== valueId);
      if (next.length) {
        this.facets[key] = next.join('|');
      } else {
        delete this.facets[key];
      }
    }

    this.skip = 0;
    const params = {
      sort: this.sort,
      ...this.facets,
      skip: this.skip,
    };
    const body = {
      primaryList: {
        include: true,
      },
    };

    try {
      const data = await this.getGridData(params, body, true);
      this.replaceSectionWithData(data);
    } catch (error) {
      console.error(' voyado: error removing filter', error);
    }
  }

  async clearAllFilters() {
    this.facets = {};
    this.skip = 0;
    const params = {
      sort: this.sort,
      skip: this.skip,
    };
    const body = {
      primaryList: {
        include: true,
      },
    };

    try {
      this.closeFilterDrawer();
      const data = await this.getGridData(params, body, true);
      this.replaceSectionWithData(data);
    } catch (error) {
      console.error(' voyado: error clearing filters', error);
    }
  }

  buildfilterDrawer(data) {
    document
      .querySelectorAll('.voyado-collection__filter-drawer')
      .forEach((drawer) => drawer.remove());

    const filterDrawer = document.createElement('aside');
    filterDrawer.className = 'voyado-collection__filter-drawer';
    filterDrawer.innerHTML = `
    <div class="voyado-collection__filter-drawer-content">
      <div class="voyado-collection__filter-drawer-header">
        <p class="voyado-collection__filter-drawer-title">Filter and sort</p>
        <button class="voyado-collection__filter-drawer-close">
          <span class="sr-only">Close</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 5L5 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 5L19 19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="voyado-collection__filter-drawer-body">
        <div class="voyado-collection__filter-drawer-sort-wrap">
          ${this.buildFilterSort(data, 'mobile-drawer-sort')}
        </div>
        ${this.buildFilterFacets(data)}
      </div>

      <div class="voyado-collection__filter-drawer-footer">
        <button class="voyado-collection__filter-drawer-clear-all">
          <span>Clear All</span>
        </button>
        <button class="voyado-collection__filter-drawer-apply">
          <span>See Results</span>
        </button>
      </div>
    </div>
    `;
    document.body.appendChild(filterDrawer);

    const closeButton = filterDrawer.querySelector(
      '.voyado-collection__filter-drawer-close',
    );
    //event listener to close the filter drawer
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeButton
        .closest('.voyado-collection__filter-drawer')
        .classList.remove('open');
    });

    //when clicking the aside we close the filter, does not work on child element click
    filterDrawer.addEventListener('click', (e) => {
      if (e.target.closest('.voyado-collection__filter-drawer-content')) return;
      e.preventDefault();
      this.closeFilterDrawer();
    });

    const clearAllButton = filterDrawer.querySelector(
      '.voyado-collection__filter-drawer-clear-all',
    );
    clearAllButton.addEventListener('click', (e) => {
      e.preventDefault();
      filterDrawer
        .querySelectorAll('input[type="checkbox"]')
        .forEach((input) => {
          input.checked = false;
        });
      this.clearAllFilters();
    });

    const applyButton = filterDrawer.querySelector(
      '.voyado-collection__filter-drawer-apply',
    );
    applyButton.addEventListener('click', (e) => {
      e.preventDefault();

      const sortValue = document.querySelector('#mobile-drawer-sort')?.value;
      const facetValues = filterDrawer.querySelectorAll(
        'input:not([type="range"]):checked',
      );
      const facetRanges = filterDrawer.querySelectorAll('input[type="range"]');

      this.closeFilterDrawer();
      this.UpdateDataWithFiltersAndSort(sortValue, facetValues, facetRanges);
    });
  }

  async UpdateDataWithFiltersAndSort(sortValue, facetValues, facetRanges) {
    const facetValuesArray = Array.from(facetValues);
    const facetValuesObject = {};
    facetValuesArray.forEach((input) => {
      const key = `f.${input.dataset.facetId}`;
      const value = facetValuesObject[key]
        ? `${facetValuesObject[key]}|${input.value}`
        : `${input.value}`;
      facetValuesObject[key] = value;
    });

    this.facets = { ...facetValuesObject };
    this.sort = sortValue;
    this.skip = 0; // reset the skip to 0 to get the first page of results

    const params = {
      //facetRanges: facetRanges,
      sort: this.sort,
      ...this.facets,
      skip: this.skip,
    };
    const body = {
      primaryList: {
        include: true,
      },
    };

    try {
      const data = await this.getGridData(params, body, true);
      this.replaceSectionWithData(data);
    } catch (error) {
      console.error(' voyado: error updating data with filters and sort', error);
    }
  }

  closeFilterDrawer() {
    const filterDrawer = document.querySelector(
      '.voyado-collection__filter-drawer',
    );
    if (filterDrawer) filterDrawer.classList.remove('open');
  }

  buildFilterFacets(data) {
    const filterFacetsContainer = () => {
      return data?.primaryList?.facets
        .map((facet) => {
          if (facet.type === 'RANGE') {
            return '';
          }

          return `
          <div class="voyado-collection__filter-facet-wrap">
          <voyado-accordion>
            <div class="voyado-accordion__head">
              <button class="voyado-collection__filter-facet-label">
                ${facet.label}
                <span>
                ${this.chevronIcon()}
                </span>
              </button>
            </div>
            <div class="voyado-accordion__body">
              <div class="voyado-collection__filter-facet-values">
                ${
                  facet.type === 'TEXT'
                    ? textFacetValues(facet)
                    : facet.type === 'RANGE'
                      ? // ? rangeFacetValues(facet)
                        ''
                      : facet.type === 'COLOR'
                        ? colorFacetValues(facet)
                        : facet.type === 'SIZE'
                          ? sizeFacetValues(facet)
                          : ''
                }
              </div>
            </div>
          </voyado-accordion>
          </div>
        `;
        })
        .join('');
    };

    const textFacetValues = (facet) => {
      return facet.values
        .map((value) => {
          return `
          <div>
            <input data-facet-id="${facet.id}" data-value-id="${value.id}" id="${facet.id}-${value.id}" type="checkbox" class="voyado-collection__filter-facet-value-input" value="${value.id}" ${this.isFacetValueSelected(facet.id, value) ? 'checked' : ''}>
            <label for="${facet.id}-${value.id}" class="voyado-collection__filter-facet-value-label">${value.label} (${value.count})</label>
          </div>
        `;
        })
        .join('');
    };

    const rangeFacetValues = (facet) => {
      return `
          <div>
            <input data-facet-id="${facet.id}" id="${facet.id}-range" type="range" class="voyado-collection__filter-facet-value-input" min="${facet.min}" max="${facet.max}">
            <label for="${facet.id}-range" class="voyado-collection__filter-facet-facet-label">${facet.label} ${facet.min} - ${facet.max}</label>
          </div>
        `;
    };

    const colorFacetValues = (facet) => {
      return facet.values
        .map((value) => {
          return `
          <div>
            <input data-facet-id="${facet.id}" data-value-id="${value.id}" id="${facet.id}-${value.id}" type="checkbox" class="voyado-collection__filter-facet-value-input" value="${value.id}" ${this.isFacetValueSelected(facet.id, value) ? 'checked' : ''}>
            <label for="${facet.id}-${value.id}" class="voyado-collection__filter-facet-value-label">${value.label} (${value.count})</label>
          </div>
        `;
        })
        .join('');
    };

    const sizeFacetValues = (facet) => {
      return this.getFacetValues(facet)
        .map((value) => {
          return `
          <div>
            <input data-facet-id="${facet.id}" data-value-id="${value.id}" id="${facet.id}-${value.id}" type="checkbox" class="voyado-collection__filter-facet-value-input" value="${value.id}" ${this.isFacetValueSelected(facet.id, value) ? 'checked' : ''}>
            <label for="${facet.id}-${value.id}" class="voyado-collection__filter-facet-value-label">${value.label} (${value.count})</label>
          </div>
        `;
        })
        .join('');
    };

    return filterFacetsContainer();
  }

  buildFilterSort(data, sortId) {
    const selectedSort = data.primaryList?.sort?.selected;
    const filterSortContainer = (data, sortId) => {
      return `
    <div class="voyado-collection__filter-sort-wrap">
    <label class="voyado-collection__filter-sort-label" for="${sortId}">Sort by</label>
    <select class="voyado-collection__filter-sort-select" id="${sortId}" value="${selectedSort}">
      ${data?.primaryList?.sort?.options
        .map(
          (option) => `
        <option value="${option.id}" ${
          option.id === selectedSort ? 'selected' : ''
        }>${option.label}</option>
      `,
        )
        .join('')}
    </select>
    </div>
    `;
    };

    return filterSortContainer(data, sortId);
  }

  buildLoadMoreButton(data) {
    const loadMoreWrapper = document.createElement('div');
    if (this.skip >= (data.primaryList?.totalHits ?? 0)) return loadMoreWrapper;
    loadMoreWrapper.className = 'voyado-collection__load-more-content';
    const loadMoreContent = (isLoading = false) => `
    <div class="voyado-collection__load-more-wrap">
      <a class="voyado-collection__load-more-button" href="${this.nextPageUrl()}">
        ${isLoading ? '<span>Loading...</span>' : '<span>Load More</span>'}
      </a>
      ${this.resultCount(data)}
    </div>
  `;
    loadMoreWrapper.innerHTML = loadMoreContent();

    const loadMoreButton = loadMoreWrapper.querySelector(
      '.voyado-collection__load-more-button',
    );
    loadMoreButton.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        loadMoreButton.innerHTML = '<span>Loading...</span>';
        await this.loadMoreData(loadMoreButton);
        loadMoreButton.innerHTML = '<span>Load More</span>';
      } catch (error) {
        loadMoreButton.innerHTML = '<span>Load More</span>';
        console.error(' voyado: error loading more data', error);
      }
    });

    return loadMoreWrapper;
  }

  // Real Shopify URL for the next page (e.g. /collections/foo?page=2 or
  // /search?q=bar&page=2) so crawlers can follow Load More. Clicks are
  // intercepted and load the next Voyado products instead.
  nextPageUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const nextPage = Math.floor(this.skip / this.limit) + 1;
    urlParams.set('page', nextPage);
    return `${window.location.pathname}?${urlParams.toString()}`;
  }

  replaceLoadMoreButton(data) {
    const loadMoreWrapper = this.querySelector(
      '.voyado-collection__load-more-content',
    );
    const collectionGrid = this.querySelector('.voyado-collection__wrapper');
    if (loadMoreWrapper) {
      loadMoreWrapper.remove();
    }

    collectionGrid.appendChild(this.buildLoadMoreButton(data));
  }

  chevronIcon() {
    return `
    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="black">
      </path>
    </svg>
    `;
  }

  async loadMoreData(loadMoreButton) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const page = Number(urlParams.get('page')) || 1;
      const newPage = page + 1;
      const newParams = {
        skip: this.skip,
        sort: this.sort,
        ...this.facets,
      };
      const data = await this.getGridData(newParams, {}, false);
      // update page param to match data
      urlParams.set('page', newPage);
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;

      window.history.pushState({ path: newUrl }, '', newUrl);
      this.refreshSectionWithData(data);
      if (this.skip >= data.primaryList.totalHits) {
        loadMoreButton.remove();
        return;
      }
      //updating the href for search engine crawling
      loadMoreButton.href = this.nextPageUrl();
    } catch (error) {
      console.error(' voyado: error loading more data', error);
    }
  }

  refreshSectionWithData(data) {
    this.refreshProductGrid(data);
    this.refreshResultsCount(data);
  }

  replaceSectionWithData(data) {
    this.refreshProductGrid(data, true);
    this.replaceLoadMoreButton(data);
    this.refreshResultsCount(data);
    this.refreshFiltersUI(data);
  }

  refreshFiltersUI(data) {
    this.buildMobileFilter(data);
    this.buildfilterDrawer(data);
  }

  refreshProductGrid(data, replace = false) {
    const productGrid = document.querySelector(
      '.voyado-collection__product-grid',
    );
    const newProductData = data.primaryList.productGroups;

    if (replace) {
      productGrid.innerHTML = '';
    }

    newProductData.forEach((productGroup) => {
      const voyadoProductCard = this.initProductCard(productGroup);
      productGrid.appendChild(voyadoProductCard);
    });

    this.updateProductCardAriaLabels();
  }

  refreshResultsCount(data) {
    const resultsCount = document.querySelectorAll(
      '.voyado-collection__result-count',
    );
    resultsCount.forEach((resultCount) => {
      resultCount.innerHTML = `Showing 1 - ${this.skip} of ${data.primaryList?.totalHits}`;
    });
  }
}

class VoyadoAccordion extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.querySelector(
      'button.voyado-collection__filter-facet-label',
    ).addEventListener('click', (e) => {
      e.preventDefault();
      this.classList.toggle('open');
    });
  }
}

class VoyadoSearch extends VoyadoProductGrid {
  constructor() {
    super();
    this.query = null;
    this.pageReference = '/search';
    this.origin = 'ORGANIC';
  }
  async connectedCallback() {
    const query = this.getAttribute('query');
    this.query = query;

    if (!window.legendsVoyado) {
      console.error('Legends Voyado Scripts not loaded');
      return;
    }
    const data = await this.getGridData({}, {}, true);

    this.buildVoyadoSection(data);
  }

  async getGridData(customParams = {}, customBody = {}, resetSkip = true) {
    //check if origin is in the url
    this.origin =
      new URLSearchParams(window.location.search).get('origin') || 'ORGANIC';

    const params = {
      limit: this.limit,
      skip: this.skip,
      q: this.query,
      origin: this.origin,
      ...customParams,
    };
    const body = {
      primaryList: {
        include: true,
      },
      secondaryList: {
        include: true,
      },
      ...customBody,
    };

    const response = await window.voyadoApi.query.searchPage(params, body);
    //remove origin from url
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete('origin');
    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    if (resetSkip) {
      this.skip = 0;
    }
    this.skip += response.primaryList?.productGroups?.length || 0;

    return response;
  }

  buildVoyadoSection(data) {
    const searchTitle = document.querySelector('.voyado-search__title');

    super.buildVoyadoSection(data);
    this.buildSecondarySearchContent(data);

    const queryLabel = this.query || data?.q || '';
    if (searchTitle) {
      if (data?.autoCorrect?.originalTotalHits === 0) {
        this.query = data?.autoCorrect?.q;
        searchTitle.innerHTML = `No results for "${queryLabel}". Did you mean "${data?.autoCorrect?.q}"?`;
      } else {
        searchTitle.innerHTML = `Search results for "${queryLabel}"`;
      }
    }
  }

  updateSEOTitle(data) {
    const hits = Number(data.primaryList?.totalHits);
    const queryLabel = this.query || '';
    document.title = Number.isFinite(hits) && hits > 0
      ? `${hits} Results found for "${queryLabel}" - ${window.shopName}`
      : `Search results for "${queryLabel}" - ${window.shopName}`;
  }

  async buildSecondarySearchContent(data) {
    const productGroups = data?.secondaryList?.productGroups;
    if (!productGroups || productGroups.length === 0) return;
    await ensureSwiper();

    const secondarySearchContent = document.createElement('div');
    secondarySearchContent.className = 'voyado-secondary-search-content';
    secondarySearchContent.innerHTML = `
    <h2 class="voyado-secondary-search-content__title">You Might Also Like</h2>
    <div class="voyado-slider__container"></div>
    `;
    const sliderContainer = secondarySearchContent.querySelector(
      '.voyado-secondary-search-content .voyado-slider__container',
    );
    mountVoyadoCarousel(sliderContainer, productGroups);

    this.appendChild(secondarySearchContent);
  }
}

// Every connected <voyado-predictive-search>. Opening one dropdown closes the
// others so the header search and the search-page input never overlap.
const voyadoPredictiveSearchInstances = new Set();

function closeOtherVoyadoPredictiveSearches(activeInstance) {
  voyadoPredictiveSearchInstances.forEach((instance) => {
    if (instance !== activeInstance && instance.isOpen) instance.closeDropdown();
  });
}

class VoyadoPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.limit = 4;
    this.skip = 0;
    this.query = '';
    this.emptySearchData = []; //the data returned when the search is empty
    this.pointerDownInside = false;
  }

  get isOpen() {
    return Boolean(
      this.querySelector(
        '.voyado-predictive-search__results.open, .voyado-predictive-search__suggested-search.open',
      ),
    );
  }

  connectedCallback() {
    voyadoPredictiveSearchInstances.add(this);
    if (this.initialized) return;
    this.initialized = true;
    this.initPredictiveSearch();
  }

  disconnectedCallback() {
    voyadoPredictiveSearchInstances.delete(this);
  }

  // which: 'results' (typed query) or 'suggested' (empty-state suggestions)
  openDropdown(which) {
    const { results, suggestedSearchContainer } = this;
    if (!results) return;
    closeOtherVoyadoPredictiveSearches(this);
    if (which === 'results') {
      results.classList.add('open');
      suggestedSearchContainer?.classList.remove('open');
    } else {
      results.classList.remove('open');
      suggestedSearchContainer?.classList.add('open');
    }
    this.syncAriaExpanded();
  }

  closeDropdown() {
    this.results?.classList.remove('open');
    this.suggestedSearchContainer?.classList.remove('open');
    this.syncAriaExpanded();
  }

  syncAriaExpanded() {
    if (!this.input) return;
    const open = this.isOpen;
    this.input.setAttribute('aria-expanded', open ? 'true' : 'false');
    const openPanel = open
      ? this.querySelector(
          '.voyado-predictive-search__results.open, .voyado-predictive-search__suggested-search.open',
        )
      : null;
    if (openPanel?.id) {
      this.input.setAttribute('aria-controls', openPanel.id);
    }
  }

  initPredictiveSearch() {
    const input =
      this.querySelector('input.voyado-predictive-search__input') ||
      this.querySelector('input[type="search"]') ||
      this.querySelector('input[type="text"]');
    const results = this.querySelector('.voyado-predictive-search__results');
    const suggestedSearchContainer = this.querySelector(
      '.voyado-predictive-search__suggested-search',
    );
    if (!input || !results) return;

    this.input = input;
    this.results = results;
    this.suggestedSearchContainer = suggestedSearchContainer;

    // Give panels ids so the input can point at the open one via aria-controls.
    const idBase = input.id || `VoyadoPredictiveSearch-${voyadoPredictiveSearchInstances.size}`;
    if (!results.id) results.id = `${idBase}-results`;
    if (suggestedSearchContainer && !suggestedSearchContainer.id) {
      suggestedSearchContainer.id = `${idBase}-suggested`;
    }
    input.setAttribute('aria-controls', results.id);
    this.syncAriaExpanded();

    // Create debounced search function ONCE
    const debouncedSearch = debounce(async (value) => {
      try {
        const data = await this.getSearchResults({ q: value });
        results.innerHTML = '';
        results.appendChild(this.buildSearchResults(data));
      } catch (error) {
        results.innerHTML = 'Error getting search results';
        console.error(' voyado: error getting search results', error);
        setTimeout(() => {
          results.innerHTML = '';
        }, 2000);
      }
    }, 200);

    const search = (e) => {
      this.query = e.target.value;
      if (e.target.value.length < 2) {
        this.openDropdown('suggested');
        return;
      }
      if (!results.classList.contains('open')) {
        this.openDropdown('results');
      }
      results.innerHTML = 'loading...';
      //debounce 200ms
      debouncedSearch(e.target.value);
    };

    input.addEventListener('keyup', async (e) => {
      if (e.key !== 'Escape') {
        search(e);
      }
    });

    input.addEventListener('keydown', async (e) => {
      if (e.key === 'Enter') {
        window.location.href = `/search?q=${e.target.value}&origin=ORGANIC`;
      }
    });

    // Escape closes from the input or from a focused link inside the dropdown.
    this.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !this.isOpen) return;
      const focusWasInPanel = e.target !== input;
      this.closeDropdown();
      if (focusWasInPanel) input.focus({ preventScroll: true });
    });

    input.addEventListener('focus', () => {
      this.openDropdown(this.query.length < 2 ? 'suggested' : 'results');
    });

    // Close when focus leaves this component (Tab away, or focus moves to the
    // other search). Pointer presses inside the component are ignored so a
    // click on a suggestion, product, recent search or "View results" link
    // still lands (Safari does not focus links on click, so relatedTarget
    // is null there).
    this.addEventListener('pointerdown', () => {
      this.pointerDownInside = true;
    });
    const clearPointerDown = () => {
      if (!this.pointerDownInside) return;
      setTimeout(() => {
        this.pointerDownInside = false;
      }, 0);
    };
    document.addEventListener('pointerup', clearPointerDown, true);
    document.addEventListener('pointercancel', clearPointerDown, true);

    this.addEventListener('focusout', (e) => {
      if (e.relatedTarget && this.contains(e.relatedTarget)) return;
      setTimeout(() => {
        if (this.pointerDownInside) return;
        if (this.contains(document.activeElement)) return;
        this.closeDropdown();
      }, 0);
    });

    // Close when clicking outside THIS component (a click inside the other
    // search closes this one too). composedPath survives re-rendered nodes.
    document.addEventListener('click', (e) => {
      if (!this.isOpen) return;
      const path = typeof e.composedPath === 'function' ? e.composedPath() : [];
      const inside = path.length ? path.includes(this) : this.contains(e.target);
      if (!inside) this.closeDropdown();
    });

    const initSuggestedSearch = async () => {
      try {
        await getSuggestedSearch();
        buildSuggestedSearch();
      } catch (error) {
        console.error(' voyado: error initializing suggested search', error);
      }
    };

    const getSuggestedSearch = async () => {
      this.emptySearchData = await this.getSearchResults({ q: '' });

    };

    const buildSuggestedSearch = () => {
      const phraseSuggestions = this.emptySearchData?.phraseSuggestions;
      const recentSearches = this.emptySearchData?.recentSearches;

      suggestedSearchContainer.innerHTML = `
          ${
            phraseSuggestions.length > 0
              ? `
                <div>
                  <p class="voyado-predictive-search__results-title">Suggestions</p>
                  <div class="voyado-predictive-search__results-suggestions">
                  ${phraseSuggestions
                    .map((search) => {
                      const highlightedContent = search.highlighted
                        .replace('{', '<strong>')
                        .replace('}', '</strong>');
                      return `
                    <a href="/search?q=${search.q}&origin=PHRASE_SUGGEST">${highlightedContent}</a>
                    `;
                    })
                    .join('')}
                  </div>
                </div>
                `
              : ''
          }
          ${
            recentSearches.length > 0
              ? `
                <div>
                  <p class="voyado-predictive-search__results-title">Recent Searches</p>
                  <div class="voyado-predictive-search__results-suggestions">
                  ${recentSearches
                    .map((search) => {
                      return `
                    <a href="/search?q=${search.q}&origin=RECENT_SEARCH">${search.q}</a>
                    `;
                    })
                    .join('')}
                  </div>
                </div>
                `
              : ''
          }
      `;
      return suggestedSearchContainer;
    };

    initSuggestedSearch();
  }

  async getSearchResults(customParams = {}, customBody = {}) {
    const params = {
      limit: this.limit,
      skip: this.skip,
      notify: true,
      ...customParams,
    };
    const body = {
      primaryList: {
        include: true,
      },
      contentLists: [
        { id: 'all-content', contentFilter: { type: ['category'] } },
      ],
      ...customBody,
    };

    const response = await window.voyadoApi.query.autocomplete(params, body);

    return response;
  }

  buildProductCards(productSuggestion) {
    const productData = productSuggestion.products[0];
    const voyadoProductCard = document.createElement('voyado-product-card');
    voyadoProductCard.productData = productData;
    return voyadoProductCard;
  }

  buildSearchResults(data) {
    const productSuggestions = data?.productSuggestions || [];
    const phraseSuggestions = data?.phraseSuggestions || [];
    const parsedHits = Number(data?.totalHits);
    const totalHits =
      Number.isFinite(parsedHits) && parsedHits > 0 ? parsedHits : null;
    const resultsContainer = document.createElement('div');
    const collectionSuggestions = data?.contentLists?.[0]?.items || [];
    const productCards = productSuggestions
      .map((productSuggestion) => this.buildProductCards(productSuggestion))
      .filter(Boolean);
    const hasProducts = productCards.length > 0;
    resultsContainer.className = hasProducts
      ? 'voyado-predictive-search__results-wrap voyado-predictive-search__results-wrap--with-products'
      : 'voyado-predictive-search__results-wrap';

    const phraseMarkup =
      phraseSuggestions.length > 0
        ? `
      <div>
        <p class="voyado-predictive-search__results-title">Suggestions</p>
        <div class="voyado-predictive-search__results-suggestions">
        ${phraseSuggestions
          .map((search) => {
            const highlightedContent = (search.highlighted || search.q || '')
              .replace('{', '<strong>')
              .replace('}', '</strong>');
            return `
          <a href="/search?q=${search.q}&origin=PHRASE_SUGGEST">${highlightedContent}</a>
          `;
          })
          .join('')}
        </div>
      </div>
      `
        : '';

    const collectionMarkup =
      collectionSuggestions.length > 0
        ? `
      <div>
        <p class="voyado-predictive-search__results-title">Collections</p>
        <div class="voyado-predictive-search__results-suggestions">
        ${collectionSuggestions
          .map((item) => {
            return `
          <a href="${item.link}" data-ticket="${item.ticket}">${item.title}</a>
          `;
          })
          .join('')}
        </div>
      </div>
      `
        : '';

    resultsContainer.innerHTML = `
    <div class="voyado-predictive-search__results-text">
      ${phraseMarkup}
      ${collectionMarkup}
      <a class="voyado-predictive-search__results-view-all" href="/search?q=${this.query}">${
        totalHits == null
          ? `View results for "${this.query}"`
          : `View ${totalHits} ${totalHits === 1 ? 'Result' : 'Results'} for "${this.query}"`
      }</a>
    </div>
    ${
      hasProducts
        ? `
    <div class="voyado-predictive-search__results-products-col">
      <p class="voyado-predictive-search__results-title">Products</p>
      <div class="voyado-predictive-search__results-products"></div>
    </div>
    `
        : ''
    }
    `;
    const productGrid = resultsContainer.querySelector(
      '.voyado-predictive-search__results-products',
    );
    if (productGrid) {
      productCards.forEach((productCard) => {
        productGrid.appendChild(productCard);
      });
    }

    resultsContainer.addEventListener('click', (e) => {
      const ticketLink = e.target.closest('a[data-ticket]');
      if (!ticketLink) return;

      const ticket = ticketLink.dataset.ticket;
      if (!ticket) return;

      e.preventDefault();
      window.voyadoApi.notify
        .click(ticket)
        .finally(() => {
          window.location.href = ticketLink.href;
        });
    });

    return resultsContainer;
  }
}

class VoyadoSlider extends HTMLElement {
  constructor() {
    super();
    this.pageReference = null;
    this.limit = 24;
  }
  connectedCallback() {
    this.pageReference = this.getAttribute('page-reference') || '';
    this.limit = this.getAttribute('limit') || this.limit;
    if (this.pageReference === '') {
      console.error('voyado: page reference is required');
      return;
    }
    if (!window.legendsVoyado) {
      console.error('Legends Voyado Scripts not loaded');
      return;
    }
    this.initSlider();
  }

  async getSliderData() {
    const params = {
      pageReference: this.pageReference,
      limit: this.limit,
    };
    const body = {};

    const response = await window.voyadoApi.query.landingPage(params, body);
    return response;
  }

  async initSlider() {
    await ensureSwiper();
    const data = await this.getSliderData();
    const productGroups =
      data.recommendationLists?.[0]?.productGroups ||
      data.primaryList?.productGroups ||
      [];
    mountVoyadoCarousel(this.querySelector('.voyado-slider__container'), productGroups);

  }
}

class VoyadoFeatureGrid extends VoyadoSlider {
  constructor() {
    super();
    this.pageReference = null;
    this.limit = 4;
  }
  connectedCallback() {
    this.pageReference = this.getAttribute('page-reference') || '';
    if (this.pageReference === '') {
      console.error('voyado: page reference is required');
      return;
    }
    if (!window.legendsVoyado) {
      console.error('Legends Voyado Scripts not loaded');
      return;
    }
    this.initFeatureGrid();
  }

  async initFeatureGrid() {
    const data = await this.getSliderData();
    const featureGridContainer = this.querySelector('.voyado-feature_grid');
    if (!featureGridContainer) return;
    const productGroups =
      data?.recommendationLists?.[0]?.productGroups ||
      data?.primaryList?.productGroups ||
      [];
    const limit = Number(this.limit) || 4;
    featureGridContainer.innerHTML = '';
    productGroups.slice(0, limit).forEach((productGroup) => {
      const productData = productGroup?.products?.[0];
      if (!productData) return;
      const productCard = document.createElement('voyado-product-card');
      productCard.productData = productData;
      featureGridContainer.appendChild(productCard);
    });
  }
}

class VoyadoRecommendations extends VoyadoSlider {
  constructor() {
    super();
    this.productId = null;
    this.limit = 16;
  }
  connectedCallback() {
    this.productId = this.getAttribute('product-id') || '';
    this.limit = this.getAttribute('limit') || this.limit;
    if (this.productId === '') {
      console.error('voyado: product id is required');
      return;
    }
    this.initRecommendations();
  }

  async initRecommendations() {
    await ensureSwiper();
    const data = await this.getProductData();
    const productGroups =
      data?.recommendationLists?.[0]?.productGroups ||
      data?.primaryList?.productGroups ||
      [];
    const sliderContainer = this.querySelector('.voyado-slider__container');
    if (!sliderContainer) return;
    if (!productGroups.length) {
      this.hidden = true;
      return;
    }
    mountVoyadoCarousel(sliderContainer, productGroups);

  }

  async getProductData() {
    const params = {
      productKey: this.productId,
      limit: this.limit,
    };
    const body = {
      productGroup: {
        include: true,
      },
      recommendationLists: [
        {
          id: 'RECS1',
          algorithm: 'UPSELL',
          limit: this.limit,
          params: {
            productKey: this.productId,
          },
          visualization: 'CAROUSEL',
        },
      ],
    };

    const response = await window.voyadoApi.query.productPage(params, body);
    return response;
  }
}

customElements.define('voyado-accordion', VoyadoAccordion);
customElements.define('voyado-product-card', VoyadoProductCard);
customElements.define('voyado-product-grid', VoyadoProductGrid);
customElements.define('voyado-search', VoyadoSearch);
customElements.define('voyado-predictive-search', VoyadoPredictiveSearch);
customElements.define('voyado-slider', VoyadoSlider);
customElements.define('voyado-feature-grid', VoyadoFeatureGrid);
customElements.define('voyado-recommendations', VoyadoRecommendations);

const voyadoAddToCartTickets = new Map();
const voyadoClickTickets = new Map();
const voyadoProductPageCache = new Map();

async function getVoyadoProductPage(productId) {
  const api = window.voyadoApi || window.elevate;
  if (!api || !productId) return;
  const cacheKey = String(productId);
  if (!voyadoProductPageCache.has(cacheKey)) {
    try {
      const productData = await api.query.productPage(
        { productKey: cacheKey },
        { productGroup: { include: true } },
      );
      voyadoProductPageCache.set(cacheKey, productData || {});
    } catch (error) {
      console.error('Voyado product page lookup failed:', error);
      voyadoProductPageCache.set(cacheKey, null);
    }
  }
  return voyadoProductPageCache.get(cacheKey) || null;
}

async function getVoyadoAddToCartTicket(productId, variantId) {
  const cacheKey = String(productId);
  if (!voyadoAddToCartTickets.has(cacheKey)) {
    const productData = await getVoyadoProductPage(productId);
    if (!productData) return;
    const variantTickets = { ...(productData.tickets || {}) };
    (productData.productGroup?.products || []).forEach((product) => {
      (product.variants || []).forEach((variant) => {
        if (variant?.key && variant?.ticket) {
          variantTickets[String(variant.key)] = variant.ticket;
        }
      });
    });
    voyadoAddToCartTickets.set(cacheKey, variantTickets);
  }

  const tickets = voyadoAddToCartTickets.get(cacheKey) || {};
  if (variantId != null && tickets[String(variantId)]) {
    return tickets[String(variantId)];
  }
  const firstTicketKey = Object.keys(tickets)[0];
  return firstTicketKey != null ? tickets[firstTicketKey] : undefined;
}

async function getVoyadoClickTicket(productId) {
  const cacheKey = String(productId);
  if (voyadoClickTickets.has(cacheKey)) {
    return voyadoClickTickets.get(cacheKey);
  }
  const productData = await getVoyadoProductPage(productId);
  const clickTicket =
    productData?.productGroup?.products?.[0]?.ticket ||
    productData?.primaryList?.productGroups?.[0]?.products?.[0]?.ticket ||
    null;
  voyadoClickTickets.set(cacheKey, clickTicket);
  return clickTicket;
}

async function notifyVoyadoAddToCart(productId, variantId) {
  const ticket = await getVoyadoAddToCartTicket(productId, variantId);
  if (ticket != null && window.voyadoApi) {
    window.voyadoApi.notify.addToCart(ticket);
  }
}

function productIdFromAddToCartForm(form) {
  const addButton = form.querySelector(
    'button[type="submit"][name="add"][product-id]',
  );
  return (
    (addButton && addButton.getAttribute('product-id')) ||
    form.getAttribute('product-id') ||
    ''
  );
}

function variantIdFromAddToCartForm(form) {
  const addButton = form.querySelector(
    'button[type="submit"][name="add"][variant-id]',
  );
  const variantInput = form.querySelector('input[name="id"]');
  return (
    (variantInput && variantInput.value) ||
    (addButton && addButton.getAttribute('variant-id')) ||
    ''
  );
}

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;

    const productId = productIdFromAddToCartForm(form);
    if (!productId) return;

    notifyVoyadoAddToCart(productId, variantIdFromAddToCartForm(form));
  },
  true,
);

async function notifyVoyadoClick(productId) {
  const api = window.voyadoApi || window.elevate;
  const ticket = await getVoyadoClickTicket(productId);
  if (ticket != null && api) {
    try {
      await api.notify.click(ticket);
    } catch (error) {
      console.error('Voyado click notify failed:', error);
    }
  }
}

function prefetchVoyadoClickTickets(root = document) {
  root.querySelectorAll('.cart-upsell .product-card-wrapper[product-id]').forEach((card) => {
    const productId = card.getAttribute('product-id');
    if (productId) getVoyadoClickTicket(productId);
  });
}

document.addEventListener(
  'click',
  (event) => {
    if (event.button != null && event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const cartUpsellCard = event.target.closest(
      '.cart-upsell .product-card-wrapper[product-id]',
    );
    const card =
      cartUpsellCard || event.target.closest('.product-card-wrapper[product-id]');
    if (!card) return;

    if (
      !cartUpsellCard &&
      (event.defaultPrevented ||
        event.target.closest(
          'voyado-product-card, a[data-ticket], button, form, modal-opener',
        ))
    ) {
      return;
    }

    const link = event.target.closest('a[href]');
    if (!link || !card.contains(link)) return;
    if (link.getAttribute('aria-disabled') === 'true') return;

    let isProductLink = false;
    try {
      isProductLink = new URL(link.href, window.location.origin).pathname.includes(
        '/products/',
      );
    } catch (error) {
      return;
    }
    if (!isProductLink) return;

    event.preventDefault();
    const href = link.href;
    notifyVoyadoClick(card.getAttribute('product-id')).finally(() => {
      window.location.href = href;
    });
  },
  true,
);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => prefetchVoyadoClickTickets());
} else {
  prefetchVoyadoClickTickets();
}
document.addEventListener('cart:updated', () => prefetchVoyadoClickTickets());

function voyadoHighlightPhrase(highlighted, fallback) {
  const source = highlighted || fallback || '';
  return voyadoEscapeHtml(source)
    .replace(/\{/g, '<mark>')
    .replace(/\}/g, '</mark>');
}

function buildVoyadoPredictiveMarkup(data, searchTerm) {
  const phraseSuggestions = data?.phraseSuggestions || [];
  const productSuggestions = (data?.productSuggestions || [])
    .map((group) => group?.products?.[0])
    .filter(Boolean);
  const collectionSuggestions = data?.contentLists?.[0]?.items || [];
  const hasSuggestions = phraseSuggestions.length > 0 || collectionSuggestions.length > 0;
  const hasProducts = productSuggestions.length > 0;
  const totalVisible =
    phraseSuggestions.length + collectionSuggestions.length + productSuggestions.length;
  const escapedTerm = voyadoEscapeHtml(searchTerm);

  const suggestionItems = [
    ...phraseSuggestions.map((search, index) => {
      const q = search.q || '';
      return `
        <li id="predictive-search-option-query-${index + 1}" class="predictive-search__list-item" role="option" aria-selected="false">
          <a href="/search?q=${encodeURIComponent(q)}&origin=PHRASE_SUGGEST" class="predictive-search__item link link--text" tabindex="-1">
            <div class="predictive-search__item-content predictive-search__item-content--centered">
              <p class="predictive-search__item-heading predictive-search__item-query-result h5">${voyadoHighlightPhrase(search.highlighted, q)}</p>
            </div>
          </a>
        </li>`;
    }),
    ...collectionSuggestions.map((item, index) => {
      const href = item.link || '#';
      const ticketAttr = item.ticket ? ` data-ticket="${voyadoEscapeHtml(item.ticket)}"` : '';
      return `
        <li id="predictive-search-option-collection-${index + 1}" class="predictive-search__list-item" role="option" aria-selected="false">
          <a href="${voyadoEscapeHtml(href)}" class="predictive-search__item link link--text" tabindex="-1"${ticketAttr}>
            <div class="predictive-search__item-content predictive-search__item-content--centered">
              <p class="predictive-search__item-heading h5">${voyadoEscapeHtml(item.title || '')}</p>
            </div>
          </a>
        </li>`;
    }),
  ].join('');

  const productItems = productSuggestions
    .map((product, index) => {
      const href = product.link || '#';
      const ticketAttr = product.ticket ? ` data-ticket="${voyadoEscapeHtml(product.ticket)}"` : '';
      const imageUrl = product.imageInfo?.images?.[0]?.sources?.[0]?.url || '';
      const imageAlt = product.imageInfo?.images?.[0]?.alt || product.title || '';
      const image = imageUrl
        ? `<img class="predictive-search__image" src="${voyadoEscapeHtml(imageUrl)}" alt="${voyadoEscapeHtml(imageAlt)}" width="50" height="50">`
        : '';
      return `
        <li id="predictive-search-option-product-${index + 1}" class="predictive-search__list-item" role="option" aria-selected="false">
          <a href="${voyadoEscapeHtml(href)}" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1"${ticketAttr}>
            ${image}
            <div class="predictive-search__item-content predictive-search__item-content--centered">
              <p class="predictive-search__item-heading h5">${voyadoEscapeHtml(product.title || '')}</p>
            </div>
          </a>
        </li>`;
    })
    .join('');

  const suggestionsGroup = hasSuggestions
    ? `
      <div class="predictive-search__result-group">
        <div>
          <h2 id="predictive-search-queries" class="predictive-search__heading text-body caption-with-letter-spacing">Suggestions</h2>
          <ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-queries">
            ${suggestionItems}
          </ul>
        </div>
      </div>`
    : '';

  const productsGroup = hasProducts
    ? `
      <div class="predictive-search__result-group">
        <div>
          <h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>
          <ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products">
            ${productItems}
          </ul>
        </div>
      </div>`
    : '';

  const groupsClass = [
    'predictive-search__results-groups-wrapper',
    hasProducts ? '' : 'predictive-search__results-groups-wrapper--no-products',
    hasSuggestions ? '' : 'predictive-search__results-groups-wrapper--no-suggestions',
  ]
    .filter(Boolean)
    .join(' ');

  const groups =
    hasSuggestions || hasProducts
      ? `<div id="predictive-search-results-groups-wrapper" class="${groupsClass}">${suggestionsGroup}${productsGroup}</div>`
      : '';

  const liveText =
    totalVisible === 0
      ? `No results found for “${escapedTerm}”`
      : `${totalVisible} result${totalVisible === 1 ? '' : 's'}`;

  return `
    <div id="predictive-search-results" role="listbox">
      ${groups}
      <div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">
        <button class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1" role="option" aria-selected="false" type="submit">
          <span data-predictive-search-search-for-text>Search for “${escapedTerm}”</span>
        </button>
      </div>
    </div>
    <span class="hidden" data-predictive-search-live-region-count-value>${liveText}</span>
  `;
}

async function waitForVoyadoAutocomplete(timeoutMs = 5000) {
  const started = Date.now();
  while (!window.voyadoApi?.query?.autocomplete && Date.now() - started < timeoutMs) {
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
  return window.voyadoApi;
}

function defineVoyadoHeaderPredictiveSearch() {
  const SearchFormBase = customElements.get('search-form');
  if (!SearchFormBase) {
    console.error('voyado: search-form is not defined');
    return;
  }
  if (customElements.get('predictive-search')) {
    console.warn('voyado: predictive-search already defined, skipping Voyado header search');
    return;
  }

  class VoyadoHeaderPredictiveSearch extends SearchFormBase {
    constructor() {
      super();
      this.cachedResults = {};
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
      this.isOpen = false;
      this.searchTerm = '';
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      super.onChange();
      const newSearchTerm = this.getQuery();
      if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
        this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
      }

      this.updateSearchForTerm(this.searchTerm, newSearchTerm);
      this.searchTerm = newSearchTerm;

      if (!this.searchTerm.length) {
        this.close(true);
        return;
      }

      this.getSearchResults(this.searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) {
        this.searchTerm = '';
        this.closeResults(true);
      }
    }

    onFocus() {
      const currentSearchTerm = this.getQuery();
      if (!currentSearchTerm.length) return;

      if (this.searchTerm !== currentSearchTerm) {
        this.onChange();
      } else if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(this.searchTerm);
      }
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onKeyup(event) {
      if (!this.getQuery().length) this.close(true);
      event.preventDefault();

      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up');
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    }

    onKeydown(event) {
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        event.preventDefault();
      }
    }

    updateSearchForTerm(previousTerm, newTerm) {
      const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
      const currentButtonText = searchForTextElement?.innerText;
      if (currentButtonText && previousTerm) {
        if (currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) {
          return;
        }
        searchForTextElement.innerText = currentButtonText.replace(previousTerm, newTerm);
      }
    }

    switchOption(direction) {
      if (!this.getAttribute('open')) return;

      const moveUp = direction === 'up';
      const selectedElement = this.querySelector('[aria-selected="true"]');
      const allVisibleElements = Array.from(
        this.querySelectorAll('li, button.predictive-search__item'),
      ).filter((element) => element.offsetParent !== null);
      let activeElementIndex = 0;

      if (moveUp && !selectedElement) return;

      let selectedElementIndex = -1;
      let i = 0;
      while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
        if (allVisibleElements[i] === selectedElement) {
          selectedElementIndex = i;
        }
        i++;
      }

      this.statusElement.textContent = '';

      if (!moveUp && selectedElement) {
        activeElementIndex =
          selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
      } else if (moveUp) {
        activeElementIndex =
          selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
      }

      if (activeElementIndex === selectedElementIndex) return;

      const activeElement = allVisibleElements[activeElementIndex];
      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);
      this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
      const selectedOption = this.querySelector(
        '[aria-selected="true"] a, button[aria-selected="true"]',
      );
      if (selectedOption) selectedOption.click();
    }

    async getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(/ /g, '-').toLowerCase();
      this.setLiveRegionLoadingState();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      const api = await waitForVoyadoAutocomplete();
      if (!api?.query?.autocomplete) {
        console.error('voyado: Elevate autocomplete is not available');
        this.close();
        return;
      }

      try {
        const data = await api.query.autocomplete(
          {
            limit: 6,
            skip: 0,
            notify: true,
            q: searchTerm,
          },
          {
            primaryList: { include: true },
            contentLists: [{ id: 'all-content', contentFilter: { type: ['category'] } }],
          },
        );
        const resultsMarkup = buildVoyadoPredictiveMarkup(data, searchTerm);
        this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      } catch (error) {
        console.error('voyado: header search failed', error);
        this.close();
      }
    }

    setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
      this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
      this.setLiveRegionText(this.loadingText);
      this.setAttribute('loading', true);
    }

    setLiveRegionText(statusText) {
      if (!this.statusElement) return;
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;
      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
      this.setLiveRegionResults();
      this.open();
    }

    setLiveRegionResults() {
      this.removeAttribute('loading');
      const live = this.querySelector('[data-predictive-search-live-region-count-value]');
      this.setLiveRegionText(live ? live.textContent : '');
    }

    getResultsMaxHeight() {
      this.resultsMaxHeight =
        window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
      return this.resultsMaxHeight;
    }

    open() {
      this.predictiveSearchResults.style.maxHeight =
        this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
    }

    close(clearSearchTerm = false) {
      this.closeResults(clearSearchTerm);
      this.isOpen = false;
    }

    closeResults(clearSearchTerm = false) {
      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }
      const selected = this.querySelector('[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', false);
      this.input.setAttribute('aria-activedescendant', '');
      this.removeAttribute('loading');
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false;
      this.predictiveSearchResults.removeAttribute('style');
    }
  }

  customElements.define('predictive-search', VoyadoHeaderPredictiveSearch);
}

// Header search uses <voyado-predictive-search>, not Dawn's <predictive-search> tag.

document.addEventListener(
  'click',
  (event) => {
    const ticketLink = event.target.closest('voyado-predictive-search a[data-ticket], predictive-search a[data-ticket]');
    if (!ticketLink) return;
    const ticket = ticketLink.dataset.ticket;
    if (!ticket || !window.voyadoApi?.notify?.click) return;
    event.preventDefault();
    window.voyadoApi.notify.click(ticket).finally(() => {
      window.location.href = ticketLink.href;
    });
  },
  true,
);
